<template>
  <picture v-if="availableSizes.length" class="compressed-image">
    <source
      v-for="[size, img] in availableSizes"
      :key="size"
      :media="getMedia(size)"
      :srcset="getCompleteSrcset(img)"
    />
    <img
      :class="classes"
      :loading="loading"
      :src="defaultImageSrc"
      :srcset="getCompleteSrcset(defaultImage)"
      :alt="alt"
      :style="{ objectFit, objectPosition }"
      :draggable="draggable"
      @error="onError"
    />
  </picture>
</template>

<script>
import { cdnDomain, getCompleteSrcset } from 'src/common/functions'

export default {
  name: 'UICompressedImage',
  props: {
    compressedImages: {
      type: Object,
      default: () => {},
    },
    alt: {
      type: String,
      default: '',
    },
    objectFit: {
      type: String,
      default: 'cover',
    },
    objectPosition: {
      type: String,
      default: 'center',
    },
    loading: {
      type: String,
      default: '',
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    classes: {
      type: Array,
      default: () => [],
    },
    media: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['error'],
  data() {
    return {
      defaultCompressedImageMedia: {
        xs: '(max-width: 400px)',
        sm: '(max-width: 600px)',
        md: '(max-width: 767px)',
        lg: '(max-width: 1023px)',
        xl: '(min-width: 1024px)',
      },
    }
  },
  computed: {
    availableSizes() {
      if (!this.compressedImages || !Object.keys(this.compressedImages).length) {
        return []
      }
      const images = this.compressedImages
      return Object.entries(images).filter((item) => {
        return (
          item[1] !== 'SizeType' && item[1] && item[0] !== 'id' && item[0] !== 'name' && item[0] !== 'size_settings'
        )
      })
    },
    defaultImage() {
      return this.availableSizes[this.availableSizes.length - 1][1]
    },
    defaultImageSrc() {
      return cdnDomain + this.availableSizes[this.availableSizes.length - 1][1]
    },
  },
  methods: {
    getCompleteSrcset,
    getMedia(size) {
      switch (size) {
        case 'xs':
          return this.media?.xs ? this.media.xs : this.defaultCompressedImageMedia.xs
        case 'sm':
          return this.media?.sm ? this.media.sm : this.defaultCompressedImageMedia.sm
        case 'md':
          return this.media?.md ? this.media.md : this.defaultCompressedImageMedia.md
        case 'lg':
          return this.media?.lg ? this.media.lg : this.defaultCompressedImageMedia.lg
        case 'xl':
          return this.media?.xl ? this.media.xl : this.defaultCompressedImageMedia.xl
      }
    },
    onError(e) {
      this.$emit('error', e)
    },
  },
}
</script>

<style lang="scss">
.compressed-image {
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
